/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhkath_Theologie16Inputs */

const en__field_enum_ikhkath_theologie16 = /** @type {(inputs: _Field_Enum_Ikhkath_Theologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`07 - Katholische Theologie`)
};

const de__field_enum_ikhkath_theologie16 = /** @type {(inputs: _Field_Enum_Ikhkath_Theologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`07 - Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "07 - Katholische Theologie" |
*
* @param {_Field_Enum_Ikhkath_Theologie16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhkath_theologie16 = /** @type {((inputs?: _Field_Enum_Ikhkath_Theologie16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhkath_Theologie16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhkath_theologie16(inputs)
	return de__field_enum_ikhkath_theologie16(inputs)
});
export { _field_enum_ikhkath_theologie16 as "_field_enum_IKHKATH_THEOLOGIE" }